import { QueryParams } from '@topcon/topcon-utils';

import { getDefaultNumericFilterValue, isFilterNumberValue } from './filter.utils';

export enum FilterIDs {
  UserFilters = 0,
  RequestFilters = 1,
}

export interface FilterList {
  [key: string]: string[];
}

export interface FilterNumberValue {
  operator?: string;
  operand?: string;
  unit?: string;
}

export type NumberFilterFields = keyof FilterNumberValue;

export type FilterValue = string | number | string[] | number[] | FilterNumberValue;

export interface FilterService {
  getFilters: (filterID: FilterIDs) => Filter[];
  getFiltersAsURLParams: (filterID: FilterIDs) => QueryParams;
  addFilter: (
    filterID: FilterIDs,
    filterName: string,
    filterText: string,
    value: FilterValue,
    type: string
  ) => void;
  clearFilters: (filterID: FilterIDs) => void;
  removeFilter: (filterID: FilterIDs, name: string) => void;
  toggleFilter: (filterID: FilterIDs, name: string) => void;
  updateFilters: (filterID: FilterIDs, changes: Filter[]) => void;
  getFilterIDForRoute: (pathname: string) => FilterIDs | null;
}

export interface DefaultFilter {
  type: string;
  name: string;
  field: string;
  subtext?: string;
  placeholder: string;
  options?: string[];
  operators?: string[];
  units?: string[];
}

export interface RefStationDefaultFilter {
  type: string;
  filters: DefaultFilter[];
}

export class Filter {
  target: FilterIDs;
  name: string;
  text: string;
  value: FilterValue;
  active: boolean;
  type: string;

  constructor(
    target: FilterIDs,
    name: string,
    text: string,
    value: FilterValue,
    active: boolean,
    type = 'multiselect'
  ) {
    this.target = target;
    this.name = name;
    this.text = text;
    if (isFilterNumberValue(value)) {
      this.value = { ...getDefaultNumericFilterValue(name), ...value };
    } else this.value = value;
    this.active = active;
    this.type = type;
  }

  copy() {
    return new Filter(this.target, this.name, this.text, this.value, this.active, this.type);
  }

  isDefaultValue() {
    const { value } = this;
    if (!isFilterNumberValue(value)) return false;
    const defaultValue = getDefaultNumericFilterValue(this.name);
    return (
      !value.operand && defaultValue.unit === value.unit && defaultValue.operator === value.operator
    );
  }
}
